import { render, staticRenderFns } from "./QuickMenuTransactionsComponent.vue?vue&type=template&id=4bb89a42&"
import script from "./QuickMenuTransactionsComponent.vue?vue&type=script&lang=js&"
export * from "./QuickMenuTransactionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
